import { END_POINTS } from "@/constants/url";
import emptySplitApi from "@/lib/rtk";
import { CommonResponseType } from "@/types/General";

export const searchService = emptySplitApi.injectEndpoints({
  overrideExisting: process.env.NODE_ENV === "development",
  endpoints: (builder) => ({
    searchAll: builder.query<CommonResponseType & { data: { products: any[]; brands: any[]; categories: any[]; } }, { search: string }>(
      {
        query: ({ search }) => ({
          url: `${END_POINTS.searchAllProducts}?search=${search}`,
          method: "GET", // Changed to GET as per the curl request, although the original request was POST
          headers: {
            authorizationnode: "guest",
            Cookie: "i18next=en; i18next=en",
          },
        }),
      }
    ),
  }),
});

export const { useSearchAllQuery } = searchService;